export default __webpack_public_path__ + "3f682cd7adbbe8587385d1903579dba6.svg";